import Vue from "vue";
import VueRouter from "vue-router";
/** 같은 페이지에서 같은 페이지로 $router.push 한 오률를 처리함 (ex : 홈페이지에서 홈 로고를 클릭한 경우) */
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(() => {
    return window.location.reload();
  });
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "CatalogList",
    // props: (route) => ({ propsId: Number(route.params.id) }),
    component: () => import("@/views/CatalogList.vue"),
  },
  {
    path: "/view/:seq",
    name: "CatalogView",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/CatalogView.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // console.log("scrollBehavior: to::", to);
    // console.log("scrollBehavior: from::", from);
    // console.log("scrollBehavior: savedPosition::", savedPosition);
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});
export default router;
